import { tableDefaults } from "./defaultConfig.js";

export const userTableConfig = () => ({
    ...tableDefaults,
    columns: [
        { title: "Email", field: "email", headerFilter: "input", headerFilterFunc: "like" },
        { title: "Rolle", field: "roleId" },
        { title: "Team", field: "teamId"}
    ],
});